// DEPENDENCIES //
import { Link } from 'react-scroll';

// STYLES // 
import "./footer.css"

export default function Footer() {
    return (
        <div className="footer">
            <div className="links">
                <a className="f_link" href="mailto:david@aplanetaryshift.com">Contact</a>
                
                <a className="f_link" href="https://www.instagram.com/aplanetaryshift/" target="_blank">Instagram</a>

                <a className="f_link" href="https://www.linkedin.com/in/8712ce/" target="_blank">LinkedIn</a>

                {/* <a className="f_link" href="https://www.github.com/8712ce/" target="_blank">GitHub</a> */}

                {/* <a className="f_link" href="https://www.webtoons.com/en/challenge/cleo-bjorn/list?title_no=698587&webtoon-platform-redirect=true" target="_blank">WebToon</a> */}

                <a className="f_link" href="https://www.patreon.com/aplanetaryshift" target="_blank">Patreon</a>
            </div>

            {/* BACK TO TOP BUTTON */}
            <button
                className="back-to-top"
                onClick={() =>
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    })
                }    
            >
                ▲
            </button>
            {/* <Link to="header" smooth={true} duration={500} className="back-to-top">Top</Link> */}

        </div>
    )
}